import React, { useLayoutEffect } from 'react';
import useCustomer from 'hooks/useCustomer';

import Loading from 'components/Loading';
import { useHistory } from 'react-router';

const Home = () => {
  const { customer, loading } = useCustomer({ extraFields: 'dataSources { id }' });
  const history = useHistory();

  useLayoutEffect(() => {
    if (!loading) {
      if (customer?.dataSources.length === 1) {
        history.replace(`/data-sources/${customer.dataSources[0].id}`);
      } else {
        history.replace('/data-sources');
      }
    }
  }, [loading, customer, history]);

  return <Loading />;
};

export default Home;
